export enum EntityStatus {
  CREATION_PENDING = 'CREATION_PENDING',
  CHANGE_PENDING = 'CHANGE_PENDING',
  DELETION_PENDING = 'DELETION_PENDING',
  OK = 'OK',
}
